import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import ar from "../locales/ar.json";
import cs from "../locales/cs.json";
import de from "../locales/de.json";
import en from "../locales/en.json";
import es from "../locales/es.json";
import latam from "../locales/es.json";
import fr from "../locales/fr.json";
import it from "../locales/it.json";
import languages from "../locales/languages.json"; // Common translations
import nl from "../locales/nl.json";
import pl from "../locales/pl.json";
import ru from "../locales/ru.json";
import tr from "../locales/tr.json";
import uk from "../locales/uk.json";
import { capitalizeFirstLetter } from "./helpers";
import { trimPlugin } from "./i18nPostProcessors";

// Updated deepMerge function to handle null and undefined values
function deepMerge(target, ...sources) {
  sources.forEach((source) => {
    if (typeof source !== "object" || source === null) return;
    Object.keys(source).forEach((key) => {
      if (
        source[key] &&
        typeof source[key] === "object" &&
        !Array.isArray(source[key])
      ) {
        if (!target[key]) target[key] = {};
        deepMerge(target[key], source[key]);
      } else {
        target[key] = source[key];
      }
    });
  });
  return target;
}

// Organize your language files
const languageFiles = {
  en,
  de,
  es,
  latam,
  fr,
  tr,
  ar,
  ru,
  uk,
  pl,
  cs,
  it,
  nl,
};

// Initialize the resources object
const resources = {};

// Merge common translations into each language, respecting namespaces
Object.keys(languageFiles).forEach((lang) => {
  const langTranslations = languageFiles[lang];

  // Ensure the language's translation object exists
  if (!langTranslations || typeof langTranslations !== "object") {
    console.warn(`Translations for language "${lang}" are missing or invalid.`);
    return;
  }

  // Initialize the resource for this language
  resources[lang] = {};

  // For each namespace in the common translations
  Object.keys(languages).forEach((namespace) => {
    // Initialize the namespace in the language if it doesn't exist
    if (!langTranslations[namespace]) {
      langTranslations[namespace] = {};
    }

    // Merge the common translations into the language's namespace
    deepMerge(langTranslations[namespace], languages[namespace]);
  });

  // Assign the merged translations to the resources
  resources[lang] = langTranslations;
});

const i18n = i18next.createInstance();
// const DETECTION_OPTIONS = {
//   order: ["localStorage", "navigator"],
//   caches: ["localStorage"],
// };

i18n
  // .use(LanguageDetector)
  .use(initReactI18next)
  .use(trimPlugin)
  .init({
    resources,
    debug: false,
    lng: "de",
    fallbackLng: "de",
    ns: [
      "global",
      "organization",
      "project",
      "auth",
      "survey",
      "ideaMap",
      "campaign",
      "map",
      "cookies",
      "infoPage",
      "languages",
      "system",
      "errors",
    ],
    defaultNS: "global",
    // detection: DETECTION_OPTIONS,
    interpolation: {
      defaultVariables: {
        val: "",
      },
      escapeValue: false,
    },
  });

i18n.services.formatter?.add("lowercase", (value) => {
  return value.toLowerCase();
});
i18n.services.formatter?.add("sentenceCase", (value) => {
  return capitalizeFirstLetter(value);
});

i18n.on("languageChanged", (lng) => {
  document.documentElement.setAttribute("lang", lng);
  const rtlLanguages = ["ar", "he", "fa"]; // Add more RTL languages as needed
  const direction = rtlLanguages.includes(lng) ? "rtl" : "ltr";
  document.documentElement.setAttribute("dir", direction);
});

export default i18n;
